"use strict";

var Reflux = require("reflux");

var SignalActions = Reflux.createActions({
  "show": {},
  "hide": {},
  "instantHide": {}
});

module.exports = SignalActions;



// WEBPACK FOOTER //
// ./app/shared/actions/signal-actions.js